import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "8342a83d-d841-4869-9187-ec237278abe9", content: "serving less wine", options: {} },
  { id: "18fa795c-ac99-476b-b8ca-fb7e5c834c2a", content: "opening the windows", options: {} },
  { id: "afbb4b87-e54b-432d-bd4c-762483de2157", content: "asking everyone to be quiet", options: {} },
  { id: "ebd379fe-e15d-44d3-ba0a-e8f1a7e4f300", content: "replacing all tables by smaller ones", options: {} },
  { id: "b3cfc782-83eb-40cd-92e4-69e390343998", content: "increasing the absorption area per person", options: {} },
  { id: "ca7458cb-d30d-414b-b109-99c01cd55aa4", content: "decreasing the number of seats", options: {} },
];

export const task: Task = {
  id: "df7a5d9b-1b10-4cc6-bd0c-291388d81ec7",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 2,
  },
  solutionType: "select",
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["b3cfc782-83eb-40cd-92e4-69e390343998", "ca7458cb-d30d-414b-b109-99c01cd55aa4"],
};
